<template>
  <DataTableServerPagination v-if="paginationService" icon="icon-notebook" :title="title" :columns="columns" :store="store" :createAction="createAction" :propForce="propForce" :filterAll="filterAll" :filterContact="filterContact" :filterUser="filterUser">
      <template slot="table-row-actions" slot-scope="{ props }" v-if="enableDuplicateWorkflow == true">
          <el-button type="warning" size="mini" icon="far fa-copy" v-tooltip="$t('vtool.duplicate')" @click="duplicate(props.row.id)"></el-button>
      </template>
      <template slot="table-row-estado" slot-scope="{ props }">
          <el-tag size="medium" :type="(props.row.estado==0) ? 'danger' : 'success'">{{ (props.row.estado==0) ? $t('inactive') : $t('active') }}</el-tag>
      </template>
      <template slot="table-row-email" slot-scope="{ props }">
          <span v-html="props.row.email.filter(item => !!item).join('<br>')"></span>
      </template>
      <template slot="table-row-fono" slot-scope="{ props }">
          <span v-html="props.row.fono && props.row.fono.length ? props.row.fono.filter(f => !!f).join('<br>') : ''"></span>
      </template>
      <template slot="table-row-tipo" slot-scope="{ props }">
          {{ (props.row.tipo===1) ? $t('user') : $t('components.contact') }}
      </template>
      <template slot="table-row-pordefecto" slot-scope="{ props }">
            {{ (props.row.pordefecto==0) ? $t('roles.porDefectoNo') : $t('roles.porDefectoSi') }}
      </template>
      
      <!-- Pasar slots personalizados desde el componente padre -->
      <template v-for="(_, slot) of $scopedSlots" :slot="slot" slot-scope="scope">
        <slot :name="slot" v-bind="scope"></slot>
      </template>

  </DataTableServerPagination>
  <datatable v-else icon="icon-notebook" :title="title" :columns="columns" :store="store" :createAction="createAction">
      <template slot="table-row-email" slot-scope="{ props }">
          <span v-html="props.row.email.filter(item => !!item).join('<br>')"></span>
      </template>
      
      <!-- Pasar slots personalizados desde el componente padre -->
      <template v-for="(_, slot) of $scopedSlots" :slot="slot" slot-scope="scope">
        <slot :name="slot" v-bind="scope"></slot>
      </template>
  </datatable>

</template>

<script>

export default {
props: {
  title: {
    type: String,
    default: '',
    required: false
  },
  columns: {
    type: Array,
    required: true
  },
  store: {
    type: String,
    required: true
  },
  paginationService: {
    type: Boolean,
    required: false,
    default: false
  },
  createAction: {
    type: Boolean,
    default: true
  },
  propForce: {
    type: Boolean,
    default: true
  },
  enableDuplicateWorkflow: {
    type: Boolean,
    default: false
  },
  filterAll: {
    type: Boolean,
    default: false
  },
  filterContact: {
    type: Boolean,
    default: false
  },
  filterUser: {
    type: Boolean,
    default: false
  }
},
methods: {
  duplicate (id) {
    this.$store.dispatch('procesos/duplicar', { id })
      .then(data => {
        this.$router.push({ name: 'procesos.editar', params: { id: data.id } })
        this.$notification('success')
      })
      .catch(() => this.$notification('error'))
  }
}
}
</script>
